export enum AcceptedFileTypes {
    PDF = 'PDF',
}
export interface AttachmentLibraryTableRowData {
    id: string;
    name: string;
    serviceIds: string[];
    type: string;
    size: string;
}

export type AttachmentLibraryTableData = AttachmentLibraryTableRowData[];
